import { api } from './axios';
import type { DvojbojRanking, IndividualEntryRankingItem } from '../types/dvojboj';

export const dvojbojApi = {
  /**
   * Pořadí dvojboje per kategorie — 6 mini-rankingu per `age_subcategory`.
   * Public endpoint, bez autorizace.
   */
  getDvojbojRanking: (categoryId: number) =>
    api
      .get<DvojbojRanking[]>(`/public/categories/${categoryId}/ranking-dvojboj`)
      .then((r) => r.data),

  /**
   * Pořadí jednotlivců (samostatne prihlasky bez druzstva) v jedné disciplíně.
   * Frontend grupuje per `ageSubcategory`.
   */
  getIndividualEntryRanking: (disciplineId: number) =>
    api
      .get<IndividualEntryRankingItem[]>(
        `/public/disciplines/${disciplineId}/ranking-individual-entries`,
      )
      .then((r) => r.data),
};
